export default __webpack_public_path__ + "static/scho-ffel-avatar-150x150-6800af78a60bb1b845b44c3cf8dc9d44.png";